import CookieToggleGroup from './CookieToggleGroup';

export default CookieToggleGroup;



// WEBPACK FOOTER //
// ./src/presentation/components/cookie-toggle-group/index.js